import { FieldModel } from '../form';

export default class VarColumnModel {
  readonly key: string;
  readonly pinned: FieldModel<boolean>;

  constructor({ key, pinned }: { key: string; pinned: boolean }) {
    this.key = key;
    this.pinned = new FieldModel<boolean>(pinned);
  }

  togglePin = () => {
    this.pinned.changeValue(!this.pinned.value);
  };

  static createVarColumn = ({
    key,
    pinned = false
  }: {
    key: string;
    pinned: boolean;
  }) => {
    return new VarColumnModel({ key, pinned });
  };
}
